export const enum StatsLevel {
  Bronze = 'bronze',
  Silver = 'silver',
  Gold = 'gold',
  Vip = 'vip',
}
